import { eventTracker } from '@hakimo-ui/hakimo/util';
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
} from '@heroicons/react/24/outline';
import GridSizePicker from './GridSizePicker';
import MultiCamTabs from './MultiCamTabs';
import { GridSize } from '../../util';

const trackFullScreen = eventTracker('toggle_multi_cam_fullscreen');

interface Props {
  gridSize: GridSize | null;
  onChangeGridSize: (size: GridSize | null) => void;
  isFullScreen: boolean;
  onToggleFullScreen: () => void;
}

export function MultiCamHeader(props: Props) {
  const { gridSize, onChangeGridSize, isFullScreen, onToggleFullScreen } =
    props;

  return (
    <div className="border-onlight-line-2 dark:border-ondark-line-2 bg-onlight-bg-1 dark:bg-ondark-bg-1 flex h-16 flex-none items-stretch border-b">
      <MultiCamTabs />
      <div className="flex flex-none items-center gap-2 px-4">
        <GridSizePicker value={gridSize} onChange={onChangeGridSize} />
        <button
          type="button"
          onClick={() => {
            trackFullScreen();
            onToggleFullScreen();
          }}
          title={isFullScreen ? 'Exit full screen' : 'Full screen'}
          className="text-onlight-text-1 dark:text-ondark-text-1 border-onlight-line-2 dark:border-ondark-line-2 flex items-center justify-center rounded-lg border p-2 outline-none"
        >
          {isFullScreen ? (
            <ArrowsPointingInIcon className="h-5 w-5" />
          ) : (
            <ArrowsPointingOutIcon className="h-5 w-5" />
          )}
        </button>
      </div>
    </div>
  );
}

export default MultiCamHeader;
